<template>
  <div class="dft-title_text">
    <div class="attr-item-box" v-for="(item,index) in value.attrsort" :key="index">
      <div class="attr-item-typedata" v-if="item == 'a1'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <div class="img_info">建议尺寸：750x500 像素，尺寸不匹配时，图片将被压缩或拉伸以铺满画面</div>
          <div class="ii-img-box">
            <el-image class="ii-img" :src="value.attr[item].value" fit="scale-down"></el-image>
            <div class="ii-img-btn">
              <el-upload
                class=""
                :action="$uploadURL"
                :show-file-list="false"
                :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,value.attr[item])}"
                :before-upload="beforeUpload"
              >
                <div class="">
                  更换图片
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="attr-item-typedata" v-if="item == 'a2'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button v-for="(iitem,ii) in value.attr[item].optionList" :key="ii" :label="iitem.value">{{iitem.label}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-if="item == 'a3'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">开启</el-radio-button>
            <el-radio-button label="2">关闭</el-radio-button>
          </el-radio-group>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
        type: Object,
        default: ()=>{
          return {attr:{},attrsort:[]}
        }
    },
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      // 模板默认数据
      assemblyAttr666: JSON.stringify(
            {
              attr: {
                a1: {
                  label: '背景图片', value: '', sid:'attr_s1',
                  key: 'background', type: 'data', tag: 'upload'
                },
                a2: {
                  label: '显示样式', value: '1', sid:'attr_s2',
                  showList: {
                    '1':'样式一',
                    '2':'样式二',
                    '3':'样式三',
                    '4':'样式四',
                    '5':'样式五',
                  },
                  optionList: [
                    {'label':'样式一','value':'1'},
                    {'label':'样式二','value':'2'},
                    {'label':'样式三','value':'3'},
                    {'label':'样式四','value':'4'},
                    {'label':'样式五','value':'5'},
                  ],
                  key: 'shopBanner-style', type: 'data', tag: 'radio'
                },
                a3: {
                  label: 'Logo背景色', value: '2', sid:'attr_s3',
                  showList: {
                    '1':'开启',
                    '2':'关闭',
                  },
                  key: 'logo-background', type: 'style', tag: 'radio'
                },
              },
              attrsort: [
                'a1','a2','a3',
              ]
            }
          )
    };
  },
  watch:{
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });
          
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData(){
    },
    //修改图片上传成功处理
    handleChangeUploadSuccess(res, file,ii){
      const _imgUrl = file.response.data.url;
      ii.value = _imgUrl
    },
    //图片上传之前处理
    beforeUpload(file){
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.img_info{
  color: #969799;
  font-weight: 400;
  margin-top: 8px;
  white-space: pre-wrap;
  font-size: 13px;
}
.ii-img-box{
  width: 80px;
  height: 100px;
  position: relative;
  .ii-img{
    width: 100%;
    height: 100%;
  }
  .ii-img-btn{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: rgba($color: #000000, $alpha: .4);
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    cursor: pointer;
  }
}
.attr-item-box{
  padding: 6px 10px;
  margin-bottom: 10px;
  .attr-item-typedata{
    .attr-item-label{
      margin-bottom: 5px;
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 40px)/4);
          height: 90px;
          margin: 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #333;
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;
            .ii-img-box{
              width: 80px;
              height: 100px;
              position: relative;
              .ii-img{
                width: 100%;
                height: 100%;
              }
              .ii-img-btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
            .ii-link-box{
              width: calc(100% - 80px);
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }
              .ii-link{}
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .attr-item-label{
      color: #969799;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  
}

.resetBtn{
  font-size: 13px;
  color: #356fd4;
}
.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
// 说明注释
.info-setby{
  position: relative;
  padding-bottom: 12px;
}
.info-set{
  position: absolute;
  bottom: 0;
  left: 0;
  color: #969799;
  font-size: 12px;
}
</style>